import Countries from './countries/Countries';
import ErrorCodes from './error-codes/ErrorCodes';
import Languages from './languages/Languages';
import SupportedLanguages from './supportes-languages/SupportedLanguages';

export default { ErrorCodes, Countries, Languages, SupportedLanguages };
